import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface CurrentClubState {
  clubId: string | null
  setClubId: (clubId: string | null) => void
  clear: () => void
}

/**
 * The user's currently-selected club. Persisted to localStorage so reloads
 * skip the picker. Set by the club-picker page or auto-selected when the
 * user only has access to one club.
 */
export const useCurrentClubStore = create<CurrentClubState>()(
  persist(
    (set) => ({
      clubId: null,
      setClubId: (clubId) => set({ clubId }),
      clear: () => set({ clubId: null }),
    }),
    {
      name: 'cm.currentClub',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
